import { User } from "./user";
import { Util } from "../providers/util/util";

export enum NoticeStatus {
  UnRead = "unread",
  Read = "read",
}

export class Notice {
  id: number;
  title: string;
  content: string;
  updated_at: Date;
  icon_image_url: string;
  status: string;

  constructor(fields: any) {
    for (const f in fields) {
      this[f] = fields[f];
    }
  }

  getTitle(): string {
    return this.title;
  }

  hasImage(): boolean {
    return !!this.icon_image_url;
  }

  getImageUrl(): string {
    return this.hasImage()
      ? this.icon_image_url
      : "assets/img/administrator-image.png";
  }

  getNameFromContent(): string {
    if (!!this.getContent().match(/^(.*)さん/)[1]) {
      return this.getContent().match(/^(.*)さん/)[1];
    } else {
      return "";
    }
  }

  getStrFromContent(): string {
    return this.getContent().match(/^.*(さん.*)/)[1];
  }

  getContent(): string {
    return this.content;
  }

  getUpdateAt(): Date {
    if (!(this.updated_at instanceof Date)) {
      this.updated_at = new Date(this.updated_at);
    }
    return this.updated_at;
  }

  getSubInformationStr(): string {
    const createAt = this.getUpdateAt();
    return Util.formatPostedDate(createAt);
  }

  isNotice(): Boolean {
    return this.constructor === Notice;
  }

  isActivity(): Boolean {
    return this.constructor === Activity;
  }

  isUnread(): Boolean {
    return this.status === NoticeStatus.UnRead;
  }
}

export class Activity extends Notice {
  user: User;

  getUser(): User {
    if (!(this.user instanceof User)) {
      this.user = new User(this.user);
    }
    return this.user;
  }
}

export class Alert {
  title: string;
  redrect_page: {
    path: string;
    user_id: number;
  };
  color: string;
  category: string;
}



// WEBPACK FOOTER //
// ./src/models/notice.ts